import { Button } from '@accure/ui';
import { DownloadIcon } from 'lucide-react';

import type { Site } from '@/api/fe-api/domain/entities/site';
import { Tooltip } from '@/components/ui/tooltip';
import { formatDate } from '@/utils/format/date';

export type ButtonDownloadProps = {
  site: Site;
};
export function ButtonDownload({ site }: ButtonDownloadProps) {
  const fileName = `tripped_systems_${site.fullFrontendId}_${formatDate(new Date())}.csv`;

  function downloadCSV() {
    const headers = ['', 'ID', 'Tripped since'];
    const data = site.unitStatus.tripped.map((unit, index) => [
      index + 1,
      unit.frontendId,
      formatDate(unit.since),
    ]);

    const csvContent = [
      headers.join(','),
      ...data.map((row) => row.join(',')),
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  return (
    <Tooltip content="Download table">
      <Button onClick={downloadCSV} variant="ghost">
        <DownloadIcon />
      </Button>
    </Tooltip>
  );
}
